export class Cerca {
    public idgeocerca: string;
    public longitud: string;
    public latitud: string;
    public idcompania: string;
    public idzona: number;
    public idruta: number;
}